import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { FilledIcon, OutlinedIcon } from '@one/icons';

export interface BulkActivateDeactivatePredefinedCommentComponentProps {
    onClick: VoidFunction;
    text: string;
    iconName: FilledIcon | OutlinedIcon;
}

export const BulkActivateDeactivatePredefinedCommentComponent: React.FC<
    BulkActivateDeactivatePredefinedCommentComponentProps
> = (props) => {
    const { onClick, text, iconName } = props;

    return <BulkActionButtonComponent text={text} iconName={iconName} onClick={onClick} />;
};
